// Generated by purs version 0.15.15
import * as Algorithm_NaturalSort from "../Algorithm.NaturalSort/index.js";
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Invariant from "../Data.Functor.Invariant/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_TraversableWithIndex from "../Data.TraversableWithIndex/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Variant_Tag from "../Data.Variant.Tag/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var $$switch = /* #__PURE__ */ Specular_Extra_Switch["switch"](Specular_Extra_Switch.switchRef);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var imap = /* #__PURE__ */ Data_Functor_Invariant.imap(Specular_Ref.invariantRef);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var newSlot = /* #__PURE__ */ Control_Monad_Replace.newSlot(Specular_Dom_Builder.monadReplaceBuilder);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var $$void = /* #__PURE__ */ Data_Functor["void"](Specular_Dom_Builder.functorBuilder);
var forWithIndex = /* #__PURE__ */ Data_TraversableWithIndex.forWithIndex(Specular_Dom_Builder.applicativeBuilder)(Data_TraversableWithIndex.traversableWithIndexArray);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var sortWith = /* #__PURE__ */ Data_Array.sortWith(/* #__PURE__ */ Data_Ord.ordArray(Algorithm_NaturalSort.ordSortChunk));
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var disabledIsSymbol = {
    reflectSymbol: function () {
        return "disabled";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(disabledIsSymbol);
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(labelIsSymbol);
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "options";
    }
});
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(keyIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(labelIsSymbol)(Data_Show.showString));
var OptGroupIsSymbol = {
    reflectSymbol: function () {
        return "OptGroup";
    }
};
var SingleOptionIsSymbol = {
    reflectSymbol: function () {
        return "SingleOption";
    }
};
var discard2 = /* #__PURE__ */ discard(Data_Maybe.bindMaybe);
var guard = /* #__PURE__ */ Control_Alternative.guard(Data_Maybe.alternativeMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(labelIsSymbol)(Data_Eq.eqString))()(keyIsSymbol);
var OptGroup = /* #__PURE__ */ (function () {
    function OptGroup(value0) {
        this.value0 = value0;
    };
    OptGroup.create = function (value0) {
        return new OptGroup(value0);
    };
    return OptGroup;
})();
var SingleOption = /* #__PURE__ */ (function () {
    function SingleOption(value0) {
        this.value0 = value0;
    };
    SingleOption.create = function (value0) {
        return new SingleOption(value0);
    };
    return SingleOption;
})();
var toOptionIdTag = {
    toOptionId: Data_Variant_Tag.toString
};
var toOptionId1 = function (dictShow) {
    return {
        toOptionId: Data_Show.show(dictShow)
    };
};
var toOptionId = function (dict) {
    return dict.toOptionId;
};
var toOptionIdMaybe = function (dictToOptionId) {
    var toOptionId2 = toOptionId(dictToOptionId);
    return {
        toOptionId: function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return "";
            };
            if (v instanceof Data_Maybe.Just) {
                return toOptionId2(v.value0);
            };
            throw new Error("Failed pattern match at Specular.Select (line 89, column 1 - line 91, column 37): " + [ v.constructor.name ]);
        }
    };
};
var optionLabel = function (v) {
    if (v instanceof OptGroup) {
        return v.value0.label;
    };
    if (v instanceof SingleOption) {
        return v.value0.label;
    };
    throw new Error("Failed pattern match at Specular.Select (line 151, column 1 - line 151, column 44): " + [ v.constructor.name ]);
};
var optionIndexRef = function (dictEq) {
    var eq2 = Data_Eq.eq(dictEq);
    return function (dictShow) {
        return function (dictToOptionId) {
            return function (options) {
                return function (ref) {
                    return $$switch(map(function (v) {
                        var findOptionValue = function (k) {
                            return Data_Array.findMap(function (v1) {
                                if (v1.value1 instanceof OptGroup) {
                                    return map1(function (v2) {
                                        return show(v1.value0) + ("/" + show(v2));
                                    })(Data_Array.findIndex(function (option) {
                                        return eq2(option.key)(k);
                                    })(v1.value1.value0.options));
                                };
                                if (v1.value1 instanceof SingleOption) {
                                    var $162 = eq2(v1.value1.value0.key)(k);
                                    if ($162) {
                                        return new Data_Maybe.Just(show(v1.value0));
                                    };
                                    return Data_Maybe.Nothing.value;
                                };
                                throw new Error("Failed pattern match at Specular.Select (line 172, column 13 - line 177, column 76): " + [ v1.value1.constructor.name ]);
                            })(Data_Array.mapWithIndex(Data_Tuple.Tuple.create)(v));
                        };
                        var findKey = function (indexStr) {
                            var v1 = function (v2) {
                                var v3 = function (v4) {
                                    if (Data_Boolean.otherwise) {
                                        return Data_Maybe.Nothing.value;
                                    };
                                    throw new Error("Failed pattern match at Specular.Select (line 165, column 1 - line 165, column 122): " + [ indexStr.constructor.name ]);
                                };
                                var $168 = Data_String_Common.split("/")(indexStr);
                                if ($168.length === 2) {
                                    var $169 = Data_Int.fromString($168[0]);
                                    if ($169 instanceof Data_Maybe.Just) {
                                        var $170 = Data_Int.fromString($168[1]);
                                        if ($170 instanceof Data_Maybe.Just) {
                                            var $171 = Data_Array.index(v)($169.value0);
                                            if ($171 instanceof Data_Maybe.Just && $171.value0 instanceof OptGroup) {
                                                var $172 = Data_Array.index($171.value0.value0.options)($170.value0);
                                                if ($172 instanceof Data_Maybe.Just) {
                                                    return new Data_Maybe.Just($172.value0.key);
                                                };
                                                return v3(true);
                                            };
                                            return v3(true);
                                        };
                                        return v3(true);
                                    };
                                    return v3(true);
                                };
                                return v3(true);
                            };
                            var $181 = Data_Int.fromString(indexStr);
                            if ($181 instanceof Data_Maybe.Just) {
                                var $182 = Data_Array.index(v)($181.value0);
                                if ($182 instanceof Data_Maybe.Just && $182.value0 instanceof SingleOption) {
                                    return new Data_Maybe.Just($182.value0.value0.key);
                                };
                                return v1(true);
                            };
                            return v1(true);
                        };
                        return imap(function (k) {
                            return Data_Maybe.fromMaybe("")(bind(k)(findOptionValue));
                        })(findKey)(ref);
                    })(options));
                };
            };
        };
    };
};
var select = function (dictEq) {
    var optionIndexRef1 = optionIndexRef(dictEq);
    return function (dictShow) {
        var optionIndexRef2 = optionIndexRef1(dictShow);
        return function (dictToOptionId) {
            var optionIndexRef3 = optionIndexRef2(dictToOptionId);
            var toOptionId2 = toOptionId(dictToOptionId);
            return function (props) {
                return function (options) {
                    return function (ref) {
                        var valueRef = optionIndexRef3(options)(ref);
                        return Specular_Dom_Element.el("select")([ fold(props), Specular_Dom_Element.bindValueOnChange(valueRef) ])(bind1(Specular_Dom_Builder.getParentNode)(function (node) {
                            return bind1(newSlot)(function (slot) {
                                return Data_Function.flip(subscribeDyn_)(options)(function (options$prime) {
                                    return function __do() {
                                        Control_Monad_Replace.replaceSlot(slot)($$void(forWithIndex(options$prime)(function (indexOutsideGroup) {
                                            return function (opt) {
                                                if (opt instanceof OptGroup) {
                                                    return Specular_Dom_Element.el("optgroup")([ Specular_Dom_Element.attr("label")(opt.value0.label), Specular_Dom_Element.attrWhen(opt.value0.disabled)("disabled")("disabled") ])($$void(forWithIndex(opt.value0.options)(function (indexInsideGroup) {
                                                        return function (option) {
                                                            return Specular_Dom_Element.el("option")([ Specular_Dom_Element.attrWhen(option.disabled)("disabled")("disabled"), Specular_Dom_Element.attr("value")(show(indexOutsideGroup) + ("/" + show(indexInsideGroup))), Specular_Dom_Element.attr("data-option-id")(toOptionId2(option.key)) ])(Specular_Dom_Element.text(option.label));
                                                        };
                                                    })));
                                                };
                                                if (opt instanceof SingleOption) {
                                                    return Specular_Dom_Element.el("option")([ Specular_Dom_Element.attrWhen(opt.value0.disabled)("disabled")("disabled"), Specular_Dom_Element.attr("value")(show(indexOutsideGroup)), Specular_Dom_Element.attr("data-option-id")(toOptionId2(opt.value0.key)) ])(Specular_Dom_Element.text(opt.value0.label));
                                                };
                                                throw new Error("Failed pattern match at Specular.Select (line 118, column 13 - line 138, column 38): " + [ opt.constructor.name ]);
                                            };
                                        })))();
                                        var value = readDynamic(Specular_Ref.refValue(valueRef))();
                                        return Specular_Dom_Browser.setTextInputValue(node)(value)();
                                    };
                                });
                            });
                        }));
                    };
                };
            };
        };
    };
};
var naturalSortByLabels = /* #__PURE__ */ (function () {
    var sortInGroups = function (v) {
        if (v instanceof OptGroup) {
            return new OptGroup({
                label: v.value0.label,
                disabled: v.value0.disabled,
                options: sortWith(function ($239) {
                    return Algorithm_NaturalSort.naturalKey((function (v2) {
                        return v2.label;
                    })($239));
                })(v.value0.options)
            });
        };
        if (v instanceof SingleOption) {
            return new SingleOption(v.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 148, column 3 - line 148, column 101): " + [ v.constructor.name ]);
    };
    var $240 = map2(sortInGroups);
    var $241 = sortWith(function ($243) {
        return Algorithm_NaturalSort.naturalKey(optionLabel($243));
    });
    return function ($242) {
        return $240($241($242));
    };
})();
var mapOptions = function (f) {
    return map2(function (v) {
        if (v instanceof OptGroup) {
            return new OptGroup({
                label: v.value0.label,
                disabled: v.value0.disabled,
                options: map2(function (o) {
                    return {
                        disabled: o.disabled,
                        label: o.label,
                        key: f(o.key)
                    };
                })(v.value0.options)
            });
        };
        if (v instanceof SingleOption) {
            return new SingleOption({
                label: v.value0.label,
                disabled: v.value0.disabled,
                key: f(v.value0.key)
            });
        };
        throw new Error("Failed pattern match at Specular.Select (line 71, column 3 - line 75, column 45): " + [ v.constructor.name ]);
    });
};
var genericOption = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new OptGroup(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new SingleOption(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 27, column 1 - line 27, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof OptGroup) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof SingleOption) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Select (line 27, column 1 - line 27, column 54): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericOption);
var showOption = function (dictShow) {
    var showRecord1 = showRecord(showRecordFieldsCons(showRecordFieldsCons2(dictShow))(Data_Show.showBoolean));
    return {
        show: genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsCons1(showRecordFieldsConsNil(Data_Show.showArray(showRecord1)))(Data_Show.showString))(Data_Show.showBoolean))))(OptGroupIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord1))(SingleOptionIsSymbol)))
    };
};
var functorOption = {
    map: function (f) {
        return function (m) {
            if (m instanceof OptGroup) {
                return new OptGroup({
                    label: m.value0.label,
                    disabled: m.value0.disabled,
                    options: map2(function (v1) {
                        return {
                            disabled: v1.disabled,
                            label: v1.label,
                            key: f(v1.key)
                        };
                    })(m.value0.options)
                });
            };
            if (m instanceof SingleOption) {
                return new SingleOption({
                    label: m.value0.label,
                    disabled: m.value0.disabled,
                    key: f(m.value0.key)
                });
            };
            throw new Error("Failed pattern match at Specular.Select (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var flattenOptionsWith = function (f) {
    return Data_Array.concatMap(function (opt) {
        if (opt instanceof SingleOption) {
            return [ f(opt.value0) ];
        };
        if (opt instanceof OptGroup) {
            return map2(f)(opt.value0.options);
        };
        throw new Error("Failed pattern match at Specular.Select (line 56, column 3 - line 58, column 42): " + [ opt.constructor.name ]);
    });
};
var flattenOptions = /* #__PURE__ */ Data_Array.concatMap(function (v) {
    if (v instanceof OptGroup && v.value0.disabled) {
        return map2(function (o) {
            return {
                key: o.key,
                label: o.label,
                disabled: true
            };
        })(v.value0.options);
    };
    if (v instanceof OptGroup) {
        return v.value0.options;
    };
    if (v instanceof SingleOption) {
        return [ v.value0 ];
    };
    throw new Error("Failed pattern match at Specular.Select (line 48, column 3 - line 52, column 32): " + [ v.constructor.name ]);
});
var findOption = function (pred) {
    return Data_Array.findMap(function (v) {
        if (v instanceof OptGroup) {
            return Data_Array.find(pred)(v.value0.options);
        };
        if (v instanceof SingleOption) {
            var $217 = pred(v.value0);
            if ($217) {
                return new Data_Maybe.Just(v.value0);
            };
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Specular.Select (line 158, column 5 - line 162, column 53): " + [ v.constructor.name ]);
    });
};
var filterOptions = function (pred) {
    return Data_Array.mapMaybe(function (v) {
        if (v instanceof SingleOption) {
            var $220 = pred(v.value0.key);
            if ($220) {
                return new Data_Maybe.Just(new SingleOption(v.value0));
            };
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof OptGroup) {
            var options$prime = Data_Array.filter(function ($244) {
                return pred((function (v1) {
                    return v1.key;
                })($244));
            })(v.value0.options);
            return discard2(guard(!Data_Array["null"](options$prime)))(function () {
                return pure(new OptGroup({
                    label: v.value0.label,
                    disabled: v.value0.disabled,
                    options: options$prime
                }));
            });
        };
        throw new Error("Failed pattern match at Specular.Select (line 62, column 3 - line 67, column 49): " + [ v.constructor.name ]);
    });
};
var eqOption = function (dictEq) {
    var eq2 = Data_Eq.eq(Data_Eq.eqArray(eqRec(Data_Eq.eqRowCons(eqRowCons(dictEq))()(disabledIsSymbol)(Data_Eq.eqBoolean))));
    var eq3 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof OptGroup && y instanceof OptGroup) {
                    return x.value0.disabled === y.value0.disabled && x.value0.label === y.value0.label && eq2(x.value0.options)(y.value0.options);
                };
                if (x instanceof SingleOption && y instanceof SingleOption) {
                    return x.value0.disabled === y.value0.disabled && eq3(x.value0.key)(y.value0.key) && x.value0.label === y.value0.label;
                };
                return false;
            };
        }
    };
};
var containsKey = function (dictEq) {
    var eq2 = Data_Eq.eq(dictEq);
    return function (v) {
        return function (v1) {
            if (v1 instanceof SingleOption) {
                return eq2(v1.value0.key)(v);
            };
            if (v1 instanceof OptGroup) {
                return Data_Array.any(function (o) {
                    return eq2(o.key)(v);
                })(v1.value0.options);
            };
            throw new Error("Failed pattern match at Specular.Select (line 81, column 1 - line 81, column 58): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var isSelectionValid = function (dictEq) {
    var containsKey1 = containsKey(dictEq);
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just) {
                return Data_Array.any(containsKey1(v.value0))(v1);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Array["null"](v1);
            };
            throw new Error("Failed pattern match at Specular.Select (line 77, column 1 - line 77, column 77): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
export {
    toOptionId,
    OptGroup,
    SingleOption,
    flattenOptions,
    flattenOptionsWith,
    filterOptions,
    mapOptions,
    isSelectionValid,
    containsKey,
    select,
    naturalSortByLabels,
    optionLabel,
    findOption,
    optionIndexRef,
    functorOption,
    eqOption,
    genericOption,
    showOption,
    toOptionIdMaybe,
    toOptionIdTag,
    toOptionId1
};
